// Mock data for ShipMeds - International Medicine Courier

export const contact = {
  phone: "+91-9315282356",
  phoneRaw: "+919315282356",
  whatsapp: "https://wa.me/919315282356",
  email: "support@shipmeds.com",
  hours: "24X7",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Popular Countries", to: "/countries", dropdown: [
    { label: "USA", to: "/country/usa" },
    { label: "United Kingdom", to: "/country/uk" },
    { label: "Canada", to: "/country/canada" },
    { label: "Australia", to: "/country/australia" },
    { label: "UAE / Dubai", to: "/country/uae" },
    { label: "New Zealand", to: "/country/new-zealand" },
  ] },
  { label: "Popular Locations", to: "/locations", dropdown: [
    { label: "Delhi", to: "/locations" },
    { label: "Mumbai", to: "/locations" },
    { label: "Bangalore", to: "/locations" },
    { label: "Hyderabad", to: "/locations" },
    { label: "Chennai", to: "/locations" },
    { label: "Pune", to: "/locations" },
  ] },
  { label: "Customs Clearance", to: "/customs-clearance", dropdown: [
    { label: "USA", to: "/customs-clearance/usa" },
    { label: "United Kingdom", to: "/customs-clearance/uk" },
    { label: "Canada", to: "/customs-clearance/canada" },
    { label: "Australia", to: "/customs-clearance/australia" },
    { label: "UAE / Dubai", to: "/customs-clearance/uae" },
    { label: "Germany", to: "/customs-clearance/germany" },
  ] },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const heroBullets = [
  "Medicines Procurement Service on Customer behalf",
  "Free Doorstep Medicine Pickup From India and International Delivery",
  "Cheapest Courier rates",
  "Help In Documentation",
  "Live Tracking",
  "24x7 Customer Support",
];

export const heroImage = "https://images.pexels.com/photos/8989470/pexels-photo-8989470.jpeg";

export const countriesList = [
  "Australia", "Bahrain", "Belgium", "Canada", "China", "Denmark", "France", "Germany",
  "Hong Kong", "Ireland", "Italy", "Japan", "Jordan", "Kenya", "Kuwait", "Lebanon",
  "Malaysia", "Netherlands", "New Zealand", "Nigeria", "Oman", "Philippines", "Poland",
  "Portugal", "Qatar", "Romania", "Russia", "Saudi Arabia", "Singapore", "South Africa",
  "South Korea", "Spain", "Sri Lanka", "Sweden", "Thailand", "UAE / Dubai",
  "United Kingdom (UK)", "United States (USA)", "Vietnam",
];

export const weightOptions = ["0.5 kg", "1.0 kg", "Above 1kg"];

export const serviceModes = [
  { id: "pickup", label: "I Want Pick Up", Icon: "Truck", desc: "Free doorstep pickup of your own medicines from anywhere in India, packed & shipped worldwide." },
  { id: "buy", label: "Buy Medicines For Me", Icon: "ShoppingBag", desc: "We procure genuine medicines from authorized pharmacies on your behalf, then courier them to you." },
];

export const medicineTypes = [
  "Allopathic Medicines",
  "Homeopathic Medicines",
  "Ayurvedic Medicines",
  "Unani or Herbal Medicines",
  "Life Saving / Chronic Medicines",
];

export const stats = [
  { value: "4.9/5", label: "Average Rating" },
  { value: "50,000+", label: "Successful Deliveries" },
  { value: "100%", label: "Customs Clearance Rate" },
  { value: "220+", label: "Countries Covered" },
];

export const capabilities = [
  {
    title: "Allopathic Medicines",
    desc: "All types of prescription drugs, tablets, capsules, syrups, and life-saving formulations.",
    img: "https://images.pexels.com/photos/15525816/pexels-photo-15525816.jpeg",
    icon: "Activity",
  },
  {
    title: "Ayurvedic & Herbal",
    desc: "Natural remedies, herbal health supplements, organic formulations, and traditional Indian products.",
    img: "https://images.unsplash.com/photo-1492552296703-4ec0a2fb3715",
    icon: "Leaf",
  },
  {
    title: "Homeopathic Medicines",
    desc: "Dilutions, pills, drops, ointments, and specialty formulas from leading homeopathic manufacturers.",
    img: "https://images.unsplash.com/photo-1725267882596-2d08e560b250",
    icon: "FlaskConical",
  },
  {
    title: "Cold Chain Shipments",
    desc: "Temperature-controlled shipping for insulin, vaccines, injections, and thermal-sensitive biologics.",
    img: "https://images.pexels.com/photos/20471642/pexels-photo-20471642.jpeg",
    icon: "Snowflake",
  },
];

export const whySteps = [
  { no: "01", title: "Free Door-to-Door Pickup & Delivery", desc: "Free medicines courier pickup from your home across India — Delhi, Gurgaon, Noida, Mumbai, Pune, Hyderabad, Chennai, Bangalore and more — with doorstep delivery to all international countries.", icon: "Truck" },
  { no: "02", title: "Reasonable Rates", desc: "We provide the best medicine courier service at low prices. Contact our team for the best discounted price and instant booking on Call / WhatsApp.", icon: "BadgeIndianRupee" },
  { no: "03", title: "Purchase of Medicines on your behalf", desc: "We buy medicines from authorized pharmacists and reputable suppliers to ensure genuine medications at maximum discount, then ship them to your destination country.", icon: "ShoppingCart" },
  { no: "04", title: "Medicines Packing Services", desc: "Our team checks the condition of medicines and determines the appropriate packing — bubble wrap, thermacol, envelopes or cardboard — to protect your medications throughout delivery.", icon: "Package" },
  { no: "05", title: "Guaranteed Delivery Timeline", desc: "We ensure guaranteed international medicine delivery within 5-6 working days and share live tracking information for total transparency.", icon: "CalendarClock" },
  { no: "06", title: "24/7 Customer Support", desc: "Whether you prefer mail, WhatsApp or Call, our team is available 24x7 to assist with inquiries, track shipments, and provide updates.", icon: "Headset" },
  { no: "07", title: "Easy Payment Options", desc: "Pay effortlessly from any part of the world using Credit cards, Debit cards, UPI, PayPal and Stripe.", icon: "CreditCard" },
];

export const flagCountries = [
  { name: "United Kingdom", code: "gb" }, { name: "Poland", code: "pl" },
  { name: "Germany", code: "de" }, { name: "France", code: "fr" },
  { name: "Kuwait", code: "kw" }, { name: "UAE", code: "ae" },
  { name: "Italy", code: "it" }, { name: "Mexico", code: "mx" },
  { name: "United States", code: "us" }, { name: "Canada", code: "ca" },
  { name: "Australia", code: "au" }, { name: "New Zealand", code: "nz" },
  { name: "Japan", code: "jp" }, { name: "Singapore", code: "sg" },
  { name: "Saudi Arabia", code: "sa" }, { name: "Qatar", code: "qa" },
  { name: "Hong Kong", code: "hk" }, { name: "Egypt", code: "eg" },
  { name: "Brazil", code: "br" }, { name: "Belgium", code: "be" },
  { name: "Nigeria", code: "ng" }, { name: "Kenya", code: "ke" },
  { name: "South Africa", code: "za" }, { name: "Malaysia", code: "my" },
  { name: "Thailand", code: "th" }, { name: "Nepal", code: "np" },
  { name: "Sri Lanka", code: "lk" }, { name: "Oman", code: "om" },
];

export const documentation = [
  { title: "Soft Copies of Prescriptions Required", desc: "We require a scan or clean photo of a valid prescription issued by a registered medical practitioner. This ensures compliance with international customs laws and pharmaceutical export statutes.", icon: "FileText" },
  { title: "Soft Copies of Bills Required", desc: "A genuine purchase retail bill from a licensed medical store or pharmacy is mandatory. The name on the bill, prescription, and packing slip must correspond for swift clearance.", icon: "ReceiptText" },
  { title: "Medicine Export Invoice Preparation", desc: "Our documentation specialists handle customs commercial invoices, MSDS declarations, and pharmaceutical export cargo lists for zero stress on your end.", icon: "ClipboardList" },
  { title: "Customs Clearance Assistance", desc: "Our team guides you through the customs clearance process to ensure your medicines are delivered promptly. Any customs duty, if applicable, is paid by the receiver.", icon: "ShieldCheck" },
];

export const processSteps = [
  { no: "01", step: "STEP 1", title: "Online Booking", desc: "Initiate your order by uploading prescription details online or calling our team.", icon: "MonitorSmartphone" },
  { no: "02", step: "STEP 2", title: "Doorstep Pickup", desc: "Our courier agent collects the medicines from your home anywhere in India for free.", icon: "Home" },
  { no: "03", step: "STEP 3", title: "Compliance Packing", desc: "We pack items in regulatory secure boxes with cold-pack support if required.", icon: "Box" },
  { no: "04", step: "STEP 4", title: "Documentation Desk", desc: "Customs specialists prepare regulatory documents, FDA/WHO compliance papers, and shipping invoices.", icon: "FileCheck2" },
  { no: "05", step: "STEP 5", title: "Transit Dispatch", desc: "Package is dispatched via DHL/FedEx network partners for priority international transit.", icon: "Plane" },
  { no: "06", step: "STEP 6", title: "Doorstep Delivery", desc: "Shipment clears customs cleanly and is delivered straight to your home address abroad.", icon: "PackageCheck" },
];

export const testimonials = [
  { name: "Sandip Ghorpade", initials: "SG", ago: "9 months ago", text: "I had an excellent experience with ShipMeds. I ordered Ayurvedic medicine from India to the UK, and they handled the entire process smoothly. The team picked up the medicines directly from the doctor and packed everything with great care." },
  { name: "Parveen", initials: "P", ago: "11 months ago", text: "I had a great experience with this courier company! I requested them to procure some important medicine from India and deliver it to me in Dubai — they managed everything seamlessly. The package arrived within 4-5 days." },
  { name: "Azmaan", initials: "A", ago: "6 months ago", text: "I had sent medicines to the US and am satisfied with the hassle free services provided. Package delivered on time. Courteous and always available on call." },
  { name: "Neha Kapoor", initials: "NK", ago: "3 months ago", text: "ShipMeds delivered my father's chronic medication to Canada without any hassle. Their documentation help made customs clearance effortless. Highly recommended!" },
  { name: "Rohan Mehta", initials: "RM", ago: "5 months ago", text: "Very professional and transparent. Live tracking kept me updated the whole time. My insulin reached Australia in perfect cold-chain condition." },
  { name: "Aisha Khan", initials: "AK", ago: "2 months ago", text: "Best rates I could find for shipping medicines to Saudi Arabia. The support team is genuinely available 24x7 and answered every question patiently." },
];

export const faqs = [
  { q: "Which medicines can you courier internationally?", a: "We ship allopathic, ayurvedic, homeopathic, unani/herbal and life-saving/chronic medicines. For cold-chain items like insulin and vaccines, we provide temperature-controlled packaging." },
  { q: "Do I need a prescription?", a: "A valid prescription and purchase bill make customs clearance smoother. If you don't have one, our tied-up pharmacy team will guide you and can procure medicines on your behalf." },
  { q: "How long does international delivery take?", a: "We guarantee delivery within 5-6 working days to most destinations, dispatched via DHL/FedEx partner networks with live tracking." },
  { q: "How much does it cost?", a: "Charges depend on destination country, weight and medicine type. Use our quote form or contact us on WhatsApp for the best discounted price." },
  { q: "How do I pay?", a: "You can pay from anywhere in the world using Credit/Debit cards, UPI, PayPal and Stripe." },
];

export const popularCountries = [
  { slug: "usa", name: "United States (USA)", code: "us", days: "5-6", price: 4400, capital: "Washington D.C." },
  { slug: "uk", name: "United Kingdom (UK)", code: "gb", days: "4-5", price: 4400, capital: "London" },
  { slug: "canada", name: "Canada", code: "ca", days: "5-6", price: 4400, capital: "Ottawa" },
  { slug: "australia", name: "Australia", code: "au", days: "5-6", price: 4400, capital: "Canberra" },
  { slug: "uae", name: "UAE / Dubai", code: "ae", days: "3-4", price: 4400, capital: "Abu Dhabi" },
  { slug: "new-zealand", name: "New Zealand", code: "nz", days: "6-7", price: 4400, capital: "Wellington" },
  { slug: "qatar", name: "Qatar", code: "qa", days: "3-4", price: 4400, capital: "Doha" },
  { slug: "singapore", name: "Singapore", code: "sg", days: "4-5", price: 4400, capital: "Singapore" },
  { slug: "germany", name: "Germany", code: "de", days: "4-5", price: 4400, capital: "Berlin" },
  { slug: "saudi-arabia", name: "Saudi Arabia", code: "sa", days: "3-4", price: 4400, capital: "Riyadh" },
  { slug: "japan", name: "Japan", code: "jp", days: "5-6", price: 4400, capital: "Tokyo" },
  { slug: "france", name: "France", code: "fr", days: "4-5", price: 4400, capital: "Paris" },
  { slug: "ireland", name: "Ireland", code: "ie", days: "4-5", price: 4400, capital: "Dublin" },
  { slug: "italy", name: "Italy", code: "it", days: "4-5", price: 4400, capital: "Rome" },
  { slug: "spain", name: "Spain", code: "es", days: "4-5", price: 4400, capital: "Madrid" },
  { slug: "netherlands", name: "Netherlands", code: "nl", days: "4-5", price: 4400, capital: "Amsterdam" },
  { slug: "sweden", name: "Sweden", code: "se", days: "5-6", price: 4400, capital: "Stockholm" },
  { slug: "switzerland", name: "Switzerland", code: "ch", days: "4-5", price: 4400, capital: "Bern" },
  { slug: "belgium", name: "Belgium", code: "be", days: "4-5", price: 4400, capital: "Brussels" },
  { slug: "poland", name: "Poland", code: "pl", days: "5-6", price: 4400, capital: "Warsaw" },
  { slug: "kuwait", name: "Kuwait", code: "kw", days: "3-4", price: 4400, capital: "Kuwait City" },
  { slug: "bahrain", name: "Bahrain", code: "bh", days: "3-4", price: 4400, capital: "Manama" },
  { slug: "oman", name: "Oman", code: "om", days: "3-4", price: 4400, capital: "Muscat" },
  { slug: "south-africa", name: "South Africa", code: "za", days: "6-7", price: 4400, capital: "Pretoria" },
  { slug: "malaysia", name: "Malaysia", code: "my", days: "4-5", price: 4400, capital: "Kuala Lumpur" },
  { slug: "thailand", name: "Thailand", code: "th", days: "4-5", price: 4400, capital: "Bangkok" },
  { slug: "china", name: "China", code: "cn", days: "5-6", price: 4400, capital: "Beijing" },
  { slug: "hong-kong", name: "Hong Kong", code: "hk", days: "4-5", price: 4400, capital: "Hong Kong" },
  { slug: "south-korea", name: "South Korea", code: "kr", days: "5-6", price: 4400, capital: "Seoul" },
  { slug: "philippines", name: "Philippines", code: "ph", days: "5-6", price: 4400, capital: "Manila" },
  { slug: "vietnam", name: "Vietnam", code: "vn", days: "5-6", price: 4400, capital: "Hanoi" },
  { slug: "sri-lanka", name: "Sri Lanka", code: "lk", days: "3-4", price: 4400, capital: "Colombo" },
  { slug: "nepal", name: "Nepal", code: "np", days: "2-3", price: 4400, capital: "Kathmandu" },
  { slug: "nigeria", name: "Nigeria", code: "ng", days: "6-7", price: 4400, capital: "Abuja" },
  { slug: "kenya", name: "Kenya", code: "ke", days: "6-7", price: 4400, capital: "Nairobi" },
  { slug: "russia", name: "Russia", code: "ru", days: "6-7", price: 4400, capital: "Moscow" },
  { slug: "denmark", name: "Denmark", code: "dk", days: "5-6", price: 4400, capital: "Copenhagen" },
  { slug: "portugal", name: "Portugal", code: "pt", days: "5-6", price: 4400, capital: "Lisbon" },
  { slug: "norway", name: "Norway", code: "no", days: "5-6", price: 4400, capital: "Oslo" },
  { slug: "mexico", name: "Mexico", code: "mx", days: "6-7", price: 4400, capital: "Mexico City" },
  { slug: "brazil", name: "Brazil", code: "br", days: "6-7", price: 4400, capital: "Brasilia" },
  { slug: "jordan", name: "Jordan", code: "jo", days: "4-5", price: 4400, capital: "Amman" },
  { slug: "lebanon", name: "Lebanon", code: "lb", days: "4-5", price: 4400, capital: "Beirut" },
];

export const customsProcess = [
  { no: "01", title: "Document Verification", desc: "We collect and verify your prescription, purchase bill and ingredient details before dispatch to ensure the paperwork matches customs requirements.", icon: "FileCheck2" },
  { no: "02", title: "Commercial Invoice & Declarations", desc: "Our documentation desk prepares the export commercial invoice, MSDS/ingredient declarations and packing list required at the destination.", icon: "ClipboardList" },
  { no: "03", title: "Destination Customs Filing", desc: "On arrival, our partners file the entry with the destination customs authority and present the compliance documents on your behalf.", icon: "Building2" },
  { no: "04", title: "Inspection & Duty Assessment", desc: "If customs inspects the parcel, our papers answer their queries. Any applicable duty is paid directly by the receiver to authorities.", icon: "ShieldCheck" },
  { no: "05", title: "Release & Doorstep Delivery", desc: "Once cleared, the shipment is released and delivered straight to the doorstep abroad, backed by our 100% clearance guarantee.", icon: "PackageCheck" },
];

export const customsNotes = {
  usa: { authority: "U.S. Customs and Border Protection (CBP) & FDA", duty: "Personal-use medicine shipments in reasonable quantities are typically duty-free; any duty is paid by the receiver.", tip: "A valid prescription and personal-use quantities clear the fastest." },
  uk: { authority: "HM Revenue & Customs (HMRC) & MHRA", duty: "Small personal shipments usually clear without duty; the receiver pays any charges if applied.", tip: "Match names on the bill, prescription and label for smooth HMRC clearance." },
  canada: { authority: "Canada Border Services Agency (CBSA) & Health Canada", duty: "Personal medicine imports are generally allowed with documentation; duty, if any, is receiver-paid.", tip: "Include a clear ingredient list for herbal and homeopathic items." },
  australia: { authority: "Australian Border Force & TGA", duty: "Personal importation is permitted with a prescription; the receiver settles any charges.", tip: "Declare herbal ingredients transparently for TGA compliance." },
  uae: { authority: "UAE Federal Customs Authority & MOHAP", duty: "Personal-use medicines clear quickly with documentation; receiver pays any duty.", tip: "Keep the prescription handy; controlled items may need extra approval." },
  germany: { authority: "German Customs (Zoll) & BfArM", duty: "Personal shipments generally clear with proper papers; duty, if any, is receiver-paid.", tip: "EU rules favour documented, personal-use quantities." },
  "saudi-arabia": { authority: "Saudi Customs & SFDA", duty: "Personal medicines clear with documentation; receiver pays applicable duty.", tip: "A prescription is strongly recommended for faster SFDA clearance." },
  qatar: { authority: "Qatar General Authority of Customs & MOPH", duty: "Personal-use shipments clear quickly; receiver settles any duty.", tip: "Keep prescription and bill ready for MOPH checks." },
  singapore: { authority: "Singapore Customs & HSA", duty: "Personal imports are allowed with documentation; receiver pays any charges.", tip: "HSA prefers clearly labelled, personal-use quantities." },
  "new-zealand": { authority: "New Zealand Customs Service & Medsafe", duty: "Personal medicine imports clear with a prescription; receiver pays any duty.", tip: "Provide ingredient details for natural health products." },
};

export const customsFaqs = [
  { q: "Who handles customs clearance at the destination?", a: "ShipMeds manages destination customs clearance end to end through our partner network, backed by a 100% clearance guarantee on Ayurvedic and Homeopathy shipments." },
  { q: "Will I have to pay customs duty?", a: "Most personal-use medicine shipments clear without duty. If any duty is applicable, it is paid directly by the receiver to the customs authority — ShipMeds has no financial interest in duties." },
  { q: "What if customs asks for more documents?", a: "Our documentation desk prepares the full compliance set upfront. If customs raises a query, our team responds with the required paperwork so your parcel is not held." },
  { q: "How long does clearance take?", a: "With complete documentation, clearance is usually quick and most parcels are delivered within the stated 3-7 working days depending on the country." },
];

export const pickupLocations = [
  { city: "Delhi", note: "Same-day free pickup across NCR" },
  { city: "Gurgaon", note: "Free doorstep collection" },
  { city: "Noida", note: "Free doorstep collection" },
  { city: "Mumbai", note: "Free pickup across the metro" },
  { city: "Pune", note: "Free doorstep collection" },
  { city: "Bangalore", note: "Same-day free pickup" },
  { city: "Hyderabad", note: "Free doorstep collection" },
  { city: "Chennai", note: "Free doorstep collection" },
  { city: "Kolkata", note: "Free doorstep collection" },
  { city: "Ahmedabad", note: "Free doorstep collection" },
  { city: "Jaipur", note: "Free doorstep collection" },
  { city: "Chandigarh", note: "Free doorstep collection" },
];

export const blogPosts = [
  {
    slug: "100-percent-customs-clearance-guarantee-ayurvedic-homeopathy",
    title: "India's First 100% Customs Clearance Guarantee on Ayurvedic & Homeopathy Medicines",
    excerpt: "ShipMeds is India's first medicine courier to offer a 100% destination customs clearance guarantee on both branded and unbranded Ayurvedic and Homeopathy medicines.",
    date: "July 2, 2025", author: "ShipMeds Team", readTime: "6 min read",
    image: "https://images.pexels.com/photos/13025947/pexels-photo-13025947.jpeg",
    tags: ["customs", "ayurvedic", "homeopathy", "guarantee"],
    body: [
      "The biggest worry when shipping Ayurvedic or Homeopathy medicines abroad is whether the parcel will clear customs at the destination. Rules differ by country, and herbal or homeopathic formulations often invite extra scrutiny. ShipMeds solves this by being India's first medicine courier to offer a 100% destination customs clearance guarantee.",
      "We handle clearance at the destination end, not just dispatch from India. Our documentation desk prepares complete commercial invoices, ingredient declarations and compliance papers for both branded products (like Patanjali, Baidyanath, SBL, Dr. Reckeweg, Willmar Schwabe) and unbranded or generic dilutions and churnas.",
      "Because we take responsibility for destination customs, you never have to chase local formalities. If any customs duty is applicable, only the receiver pays it directly to authorities; ShipMeds has no financial interest in duties. Everything else, from paperwork to follow-up, is managed by our team.",
      "This guarantee applies to Ayurvedic and Homeopathy shipments across our network. Combine it with free doorstep pickup in India and live tracking, and you get the safest way to send traditional medicines to family overseas.",
    ],
  },
  {
    slug: "send-ayurvedic-medicines-abroad-from-india",
    title: "How to Send Ayurvedic Medicines Abroad from India (Branded & Unbranded)",
    excerpt: "A complete guide to couriering branded and unbranded Ayurvedic medicines internationally with guaranteed customs clearance.",
    date: "June 28, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1492552296703-4ec0a2fb3715",
    tags: ["ayurvedic", "branded", "unbranded", "guide"],
    body: [
      "Ayurvedic medicines are in huge demand among Indians living abroad. Whether it is branded products from Patanjali, Dabur, Zandu or Baidyanath, or unbranded churnas, oils and classical formulations from a local vaidya, they can be shipped internationally when documented correctly.",
      "For branded items, keep the original sealed packaging and the purchase bill. For unbranded or loose Ayurvedic preparations, an ingredient list and the practitioner's note help immensely at destination customs. ShipMeds prepares these declarations for you.",
      "With our 100% customs clearance guarantee, you don't need to worry about whether herbal products are allowed at the destination; we handle destination clearance end to end. See our country guides for the USA, UK, Canada and UAE for specific timelines and charges.",
      "Book a free doorstep pickup, and our team collects, inspects, packs and dispatches your Ayurvedic parcel with full tracking.",
    ],
  },
  {
    slug: "ship-homeopathy-medicines-internationally",
    title: "Shipping Homeopathy Medicines Internationally: Branded & Unbranded Guide",
    excerpt: "Learn how to courier homeopathic dilutions, drops and pills - both branded and unbranded - abroad with zero customs stress.",
    date: "June 25, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1725267882596-2d08e560b250",
    tags: ["homeopathy", "branded", "unbranded", "guide"],
    body: [
      "Homeopathy remains a trusted choice for many families, and sending it overseas is straightforward with the right partner. Branded homeopathy from SBL, Dr. Reckeweg, Willmar Schwabe, Bakson and Adel ships easily with original labels and bills.",
      "Unbranded homeopathic dilutions, mother tinctures and dispensed pills from a local clinic can also be shipped. A simple composition note and the doctor's prescription support smooth clearance.",
      "ShipMeds offers a 100% destination customs clearance guarantee on homeopathy shipments. We prepare the export invoice and compliance documents so your parcel clears without hold-ups.",
      "Pack sizes for homeopathy are usually light, which keeps courier charges low. Get a quick quote or talk to our experts on WhatsApp to book.",
    ],
  },
  {
    slug: "courier-patanjali-baidyanath-ayurvedic-abroad",
    title: "Can You Courier Patanjali, Dabur & Baidyanath Ayurvedic Products Abroad?",
    excerpt: "Yes - popular branded Ayurvedic products can be shipped internationally. Here is exactly how ShipMeds does it.",
    date: "June 20, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1492552296703-4ec0a2fb3715",
    tags: ["ayurvedic", "branded"],
    body: [
      "Branded Ayurvedic products from Patanjali, Dabur, Zandu, Baidyanath and Himalaya are among the most requested items we ship. Because they carry manufacturer labelling, batch numbers and ingredient lists, they are generally the easiest Ayurvedic category to clear at customs.",
      "Keep products in their sealed original packaging and share the retail purchase bill. Our documentation team maps the ingredients to destination requirements and prepares the export invoice.",
      "With our 100% customs clearance guarantee on Ayurvedic shipments, ShipMeds takes care of destination formalities so your branded parcel reaches the doorstep abroad.",
    ],
  },
  {
    slug: "ship-branded-homeopathy-sbl-reckeweg-schwabe",
    title: "Sending Branded Homeopathy (SBL, Dr. Reckeweg, Schwabe) Overseas",
    excerpt: "A practical guide to shipping leading branded homeopathy overseas with full documentation support.",
    date: "June 16, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1725267882596-2d08e560b250",
    tags: ["homeopathy", "branded"],
    body: [
      "Branded homeopathy from SBL, Dr. Reckeweg, Willmar Schwabe, Bakson, Adel and Lord's is popular with customers overseas. These products come with clear labels, potency markings and manufacturer details that simplify clearance.",
      "Share the purchase bill and keep bottles sealed. For combination remedies, our team lists the constituents in the export invoice for transparency at customs.",
      "ShipMeds guarantees destination customs clearance on homeopathy shipments, so you can send branded remedies to the USA, UK, Canada, Australia and UAE with confidence.",
    ],
  },
  {
    slug: "shipping-unbranded-generic-ayurvedic-medicines",
    title: "Shipping Unbranded / Generic Ayurvedic Medicines: What You Need to Know",
    excerpt: "Loose churnas, classical formulations and vaidya-dispensed Ayurvedic medicines can be shipped - here is how.",
    date: "June 12, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.pexels.com/photos/15525816/pexels-photo-15525816.jpeg",
    tags: ["ayurvedic", "unbranded"],
    body: [
      "Unbranded or generic Ayurvedic medicines - churnas, bhasmas, classical kashayams and oils prepared or dispensed by a vaidya - are perfectly shippable when documented properly.",
      "The key is a clear ingredient/composition note and the practitioner's prescription. This lets our documentation desk build an accurate export invoice that satisfies destination customs.",
      "Our 100% customs clearance guarantee covers unbranded Ayurvedic shipments too. We inspect and repack loose items securely to prevent leakage or breakage in transit.",
      "If you are unsure about a specific formulation, message our Ayurvedic shipping experts on WhatsApp before booking.",
    ],
  },
  {
    slug: "shipping-unbranded-homeopathy-dilutions",
    title: "Shipping Unbranded Homeopathy Dilutions & Mother Tinctures Abroad",
    excerpt: "Clinic-dispensed dilutions and mother tinctures can travel internationally with the right paperwork.",
    date: "June 8, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1725267882596-2d08e560b250",
    tags: ["homeopathy", "unbranded"],
    body: [
      "Many homeopaths dispense unbranded dilutions, mother tinctures and medicated pills directly from their clinics. These can be couriered overseas when accompanied by a composition note and prescription.",
      "Liquid dilutions and tinctures need leak-proof packaging; our team double-seals and cushions each bottle to survive long-haul transit.",
      "ShipMeds provides a 100% destination customs clearance guarantee on unbranded homeopathy, preparing every compliance document so your parcel is not held at the border.",
    ],
  },
  {
    slug: "documents-to-ship-ayurvedic-medicines",
    title: "Documents Needed to Ship Ayurvedic Medicines Internationally",
    excerpt: "A simple checklist of documents that make Ayurvedic medicine shipments clear customs smoothly.",
    date: "June 4, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/15525816/pexels-photo-15525816.jpeg",
    tags: ["ayurvedic", "documents", "customs"],
    body: [
      "The right paperwork is what separates a smooth Ayurvedic shipment from a delayed one. For branded products, you need the retail purchase bill and sealed packaging with visible ingredient lists.",
      "For unbranded preparations, add a composition note and, where relevant, a practitioner's prescription. ShipMeds converts these into a proper commercial export invoice.",
      "Because our 100% customs clearance guarantee covers destination formalities, we tell you exactly what to provide upfront so there are no surprises later.",
    ],
  },
  {
    slug: "documents-to-ship-homeopathy-medicines",
    title: "Documents Needed to Ship Homeopathy Medicines Internationally",
    excerpt: "Everything you should keep ready to courier branded or unbranded homeopathy abroad.",
    date: "May 30, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/15525816/pexels-photo-15525816.jpeg",
    tags: ["homeopathy", "documents", "customs"],
    body: [
      "For branded homeopathy, keep the purchase bill and sealed bottles. For unbranded dilutions, a composition note and prescription help our team declare the contents accurately.",
      "Names on the bill, prescription and packing slip should match the receiver where possible. This consistency is a major factor in fast clearance.",
      "With destination clearance guaranteed by ShipMeds, you simply share soft copies and we build the rest of the documentation set.",
    ],
  },
  {
    slug: "destination-customs-clearance-explained",
    title: "Destination Customs Clearance Explained for Medicine Shipments",
    excerpt: "What destination customs clearance really means - and why a guarantee matters for herbal and homeopathic parcels.",
    date: "May 26, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.pexels.com/photos/13025947/pexels-photo-13025947.jpeg",
    tags: ["customs", "guide"],
    body: [
      "Dispatching a parcel from India is only half the journey. The real test is clearance at the destination country, where authorities check documentation and contents - especially for Ayurvedic and homeopathic products.",
      "Many couriers stop caring once the parcel leaves India. ShipMeds is different: we manage destination clearance and back it with a 100% guarantee, so your medicines are not stuck at foreign customs.",
      "If duty applies, the receiver pays it directly to customs; we have no financial interest in duty. Our role is to ensure the paperwork is flawless and the parcel moves.",
    ],
  },
  {
    slug: "india-to-usa-ayurvedic-homeopathy-courier",
    title: "India to USA: Shipping Ayurvedic & Homeopathy Medicines",
    excerpt: "Send branded and unbranded Ayurvedic and homeopathy medicines from India to the USA with guaranteed clearance.",
    date: "May 22, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/8989470/pexels-photo-8989470.jpeg",
    tags: ["ayurvedic", "homeopathy", "country"],
    country: "usa",
    body: [
      "The USA is our most requested destination for Ayurvedic and homeopathy shipments. With correct documentation, both branded and unbranded products reach doorsteps across the country in about 5-6 working days.",
      "ShipMeds prepares the export invoice and ingredient declarations, and our 100% customs clearance guarantee covers US destination formalities.",
      "See our full India to USA charges page for pricing, then book a free doorstep pickup anywhere in India.",
    ],
  },
  {
    slug: "india-to-uk-ayurvedic-homeopathy-courier",
    title: "India to UK: Shipping Ayurvedic & Homeopathy Medicines",
    excerpt: "A quick guide to couriering Ayurvedic and homeopathic medicines from India to the United Kingdom.",
    date: "May 18, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/8989470/pexels-photo-8989470.jpeg",
    tags: ["ayurvedic", "homeopathy", "country"],
    country: "uk",
    body: [
      "Shipping Ayurvedic and homeopathy medicines from India to the UK is quick, usually 4-5 working days. Branded products clear easily, and unbranded preparations are fine with a composition note.",
      "Our documentation desk builds UK-ready paperwork, and destination clearance is guaranteed by ShipMeds.",
      "Check the India to UK charges page and book a free pickup to get started.",
    ],
  },
  {
    slug: "india-to-canada-ayurvedic-homeopathy-courier",
    title: "India to Canada: Ayurvedic & Homeopathy Medicine Courier Guide",
    excerpt: "Send Ayurvedic and homeopathic medicines from India to Canada with full documentation and clearance support.",
    date: "May 14, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.unsplash.com/photo-1571086291540-b137111fa1c7",
    tags: ["ayurvedic", "homeopathy", "country"],
    country: "canada",
    body: [
      "Canada is a popular destination for herbal and homeopathic parcels from India. Delivery typically takes 5-6 working days with priority partners.",
      "ShipMeds prepares Canada-compliant invoices and ingredient declarations, backed by our 100% destination customs clearance guarantee.",
      "Visit the India to Canada charges page for pricing and book your free doorstep pickup.",
    ],
  },
  {
    slug: "india-to-uae-dubai-ayurvedic-homeopathy-courier",
    title: "India to UAE / Dubai: Ayurvedic & Homeopathy Medicine Courier",
    excerpt: "Fast, guaranteed shipping of Ayurvedic and homeopathy medicines from India to the UAE and Dubai.",
    date: "May 10, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/8989470/pexels-photo-8989470.jpeg",
    tags: ["ayurvedic", "homeopathy", "country"],
    country: "uae",
    body: [
      "The UAE and Dubai are among the fastest lanes, with delivery in about 3-4 working days. Both branded and unbranded Ayurvedic and homeopathy products ship well with the right paperwork.",
      "ShipMeds manages destination clearance in the UAE and guarantees it 100%, so your parcel is not held at customs.",
      "See the India to UAE / Dubai charges page and message us on WhatsApp to book instantly.",
    ],
  },
  {
    slug: "how-to-send-medicines-abroad-from-india",
    title: "How to Send Medicines Abroad from India: A Complete Guide",
    excerpt: "Everything you need to know about couriering medicines internationally \u2014 documents, packaging, customs and delivery timelines.",
    date: "June 12, 2025", author: "ShipMeds Team", readTime: "6 min read",
    image: "https://images.pexels.com/photos/8989470/pexels-photo-8989470.jpeg",
    body: [
      "Sending medicines from India to family and friends abroad has become common, but the process involves prescriptions, bills, packaging and customs compliance. This guide walks you through each step so your shipment reaches safely.",
      "Start by keeping a soft copy of a valid prescription and the pharmacy purchase bill. The names on both should match the receiver details for smooth customs clearance.",
      "For temperature-sensitive medicines like insulin, cold-chain packaging with gel packs is essential. Our team handles compliant packing so your medicines maintain integrity throughout transit.",
      "Finally, choose a reliable courier partner that offers live tracking and documentation support. Most international shipments are delivered within 5-6 working days.",
    ],
  },
  {
    slug: "customs-rules-for-medicine-shipping",
    title: "Customs Rules You Should Know Before Shipping Medicines",
    excerpt: "Understand international customs requirements, duty responsibilities and paperwork needed for hassle-free clearance.",
    date: "May 28, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.pexels.com/photos/13025947/pexels-photo-13025947.jpeg",
    body: [
      "Different countries have different rules for importing medicines. A valid prescription, a purchase invoice and a clear commercial invoice are usually mandatory.",
      "Any customs duty, if applicable, is generally paid by the receiver at the destination. Our documentation desk prepares MSDS declarations and export invoices to minimise delays.",
      "Life-saving and chronic-disease medications typically receive smoother clearance when the paperwork is complete and consistent.",
    ],
  },
  {
    slug: "cold-chain-shipping-explained",
    title: "Cold Chain Shipping Explained: Keeping Insulin & Vaccines Safe",
    excerpt: "Temperature-controlled logistics ensure sensitive biologics stay effective from pickup to doorstep delivery.",
    date: "May 10, 2025", author: "ShipMeds Team", readTime: "4 min read",
    image: "https://images.pexels.com/photos/20471642/pexels-photo-20471642.jpeg",
    body: [
      "Cold-chain shipping maintains a controlled temperature range for medicines like insulin, vaccines and injectables that lose potency if exposed to heat.",
      "We use insulated boxes, gel packs and thermal liners, and dispatch through priority networks to reduce transit time.",
      "Live tracking lets you monitor the shipment at every stage until it reaches the destination safely.",
    ],
  },
  {
    slug: "ayurvedic-medicine-export-tips",
    title: "Shipping Ayurvedic Medicines Overseas: Tips & Best Practices",
    excerpt: "From Patanjali to Baidyanath \u2014 how to courier ayurvedic and herbal products abroad without issues.",
    date: "April 22, 2025", author: "ShipMeds Team", readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1492552296703-4ec0a2fb3715",
    body: [
      "Ayurvedic and herbal products from trusted Indian brands are in high demand overseas. Proper labelling and ingredient declarations help clearance.",
      "Keep the original packaging and purchase bill. Some countries require ingredient lists for herbal formulations.",
      "Our team advises on the right documentation for each destination so your ayurvedic shipment arrives without surprises.",
    ],
  },
];

export const contactReasons = [
  "Get a courier quote",
  "Buy medicines on my behalf",
  "Track my shipment",
  "Documentation help",
  "Other",
];
